/** @jsx jsx */

import { Fragment } from 'react';
import { lowerCase, startCase } from 'lodash';
import { jsx, css } from '@emotion/core';

import { Badge, Text } from '@zapier/design-system';

import { VersionStatus } from 'app/developer-v3/constants';
import { usePrivatePlatform } from 'app/developer-v3/hooks';

import { SIDEBAR_TITLES, VALIDATION_RESULT_GROUPINGS } from './constants';
import {
  getPublishingTasksCheckDescription,
  getWarningCheckDescription,
} from './utils';

import type { ValidationResultType } from 'app/developer-v3/types';

const Styles = {
  title: css`
    display: flex;
    align-items: baseline;
    line-height: 1;
  `,
};

type Props = {
  checkType: ValidationResultType;
  count: number;
  hasLoaded: boolean;
  isPublished: boolean;
  versionStatus: VersionStatus;
};

export default function CheckSummary({
  checkType,
  count,
  hasLoaded,
  isPublished,
  versionStatus,
}: Props) {
  const { isPublicIntentionElementVisible } = usePrivatePlatform();

  return (
    <Fragment>
      <div css={Styles.title}>
        <Text fontWeight={600} margin="0px 5px 10px 0px" tag="h1" type="Body4">
          {checkType === VALIDATION_RESULT_GROUPINGS.activationTasks
            ? SIDEBAR_TITLES.activationTasks
            : startCase(checkType)}
        </Text>
        {hasLoaded && (
          <span aria-label={`number of ${lowerCase(checkType)}`}>
            <Badge>{`${count}`}</Badge>
          </span>
        )}
      </div>
      <Text>
        {checkType === VALIDATION_RESULT_GROUPINGS.activationTasks &&
          getPublishingTasksCheckDescription(isPublished)}
        {checkType === VALIDATION_RESULT_GROUPINGS.warnings &&
          getWarningCheckDescription(
            isPublished,
            versionStatus === VersionStatus.public,
            isPublicIntentionElementVisible
          )}
        {checkType === VALIDATION_RESULT_GROUPINGS.errors &&
          'Blocking issues that will prevent your integration from functioning properly'}
        {checkType === VALIDATION_RESULT_GROUPINGS.passes && ''}
      </Text>
    </Fragment>
  );
}
